(function () {
  'use strict';

  function updateResponsivePdpContactUpskill() {
    const screenWidth = window.innerWidth;

    // ...............
    // MOBILE.........
    // ...............

    if (screenWidth >= 320 && screenWidth <= 767) {
      const pdpContactUpskillHeadline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper h4');
      if (!pdpContactUpskillHeadline) return;
      pdpContactUpskillHeadline.classList.remove('text-headline-m-uppercase-desktop');
      pdpContactUpskillHeadline.classList.remove('text-headline-m-uppercase-mobile');
      pdpContactUpskillHeadline.classList.add('text-headline-m-mobile');

      const pdpContactUpskillSubline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper p');
      if (!pdpContactUpskillSubline) return;
      pdpContactUpskillSubline.classList.add('text-body-m');
      pdpContactUpskillSubline.classList.remove('text-headline-s-mobile');
      pdpContactUpskillSubline.classList.remove('text-headline-xs-desktop');

      const pdpContactUpskillName = document.querySelector('.Pdp-Contact-Upskill-Name-Wrapper p');
      if (!pdpContactUpskillName) return;
      pdpContactUpskillName.classList.add('text-headline-m-mobile');
      pdpContactUpskillName.classList.remove('text-headline-m-desktop');
    }

    // ................
    // TABLET..........
    // ................

    if (screenWidth >= 768 && screenWidth <= 1023) {
      const pdpContactUpskillHeadline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper h4');
      if (!pdpContactUpskillHeadline) return;
      pdpContactUpskillHeadline.classList.remove('text-headline-m-uppercase-desktop');
      pdpContactUpskillHeadline.classList.add('text-headline-m-uppercase-mobile');
      pdpContactUpskillHeadline.classList.remove('text-headline-m-mobile');

      const pdpContactUpskillSubline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper p');
      if (!pdpContactUpskillSubline) return;
      pdpContactUpskillSubline.classList.add('text-headline-s-mobile');
      pdpContactUpskillSubline.classList.remove('text-body-m');
      pdpContactUpskillSubline.classList.remove('text-headline-xs-desktop');

      const pdpContactUpskillName = document.querySelector('.Pdp-Contact-Upskill-Name-Wrapper p');
      if (!pdpContactUpskillName) return;
      pdpContactUpskillName.classList.add('text-headline-m-mobile');
      pdpContactUpskillName.classList.remove('text-headline-m-desktop');
    }

    // ................
    // LAPTOP..........
    // ................

    if (screenWidth >= 1024 && screenWidth <= 1439) {
      const pdpContactUpskillHeadline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper h4');
      if (!pdpContactUpskillHeadline) return;
      pdpContactUpskillHeadline.classList.add('text-headline-m-uppercase-desktop');
      pdpContactUpskillHeadline.classList.remove('text-headline-m-uppercase-mobile');
      pdpContactUpskillHeadline.classList.remove('text-headline-m-mobile');

      const pdpContactUpskillSubline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper p');
      if (!pdpContactUpskillSubline) return;
      pdpContactUpskillSubline.classList.add('text-headline-xs-desktop');
      pdpContactUpskillSubline.classList.remove('text-headline-s-mobile');
      pdpContactUpskillSubline.classList.remove('text-body-m');

      const pdpContactUpskillName = document.querySelector('.Pdp-Contact-Upskill-Name-Wrapper p');
      if (!pdpContactUpskillName) return;
      pdpContactUpskillName.classList.add('text-headline-m-desktop');
      pdpContactUpskillName.classList.remove('text-headline-m-mobile');
    }

    // ...............
    // DESKTOP........
    // ...............

    if (screenWidth >= 1440) {
      const pdpContactUpskillHeadline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper h4');
      if (!pdpContactUpskillHeadline) return;
      pdpContactUpskillHeadline.classList.add('text-headline-m-uppercase-desktop');
      pdpContactUpskillHeadline.classList.remove('text-headline-m-uppercase-mobile');
      pdpContactUpskillHeadline.classList.remove('text-headline-m-mobile');

      const pdpContactUpskillSubline = document.querySelector('.Pdp-Contact-Upskill-Header-Wrapper p');
      if (!pdpContactUpskillSubline) return;
      pdpContactUpskillSubline.classList.add('text-headline-xs-desktop');
      pdpContactUpskillSubline.classList.remove('text-headline-s-mobile');
      pdpContactUpskillSubline.classList.remove('text-body-m');

      const pdpContactUpskillName = document.querySelector('.Pdp-Contact-Upskill-Name-Wrapper p');
      if (!pdpContactUpskillName) return;
      pdpContactUpskillName.classList.add('text-headline-m-desktop');
      pdpContactUpskillName.classList.remove('text-headline-m-mobile');
    }
  }

  updateResponsivePdpContactUpskill();
  window.addEventListener('resize', updateResponsivePdpContactUpskill);
})();
